import { useNavigate, useSearchParams } from 'react-router'
import { useAppSelector } from '@/redux/hooks'
import { usePages } from '@/hooks'
import { NavArrowLeftIcon } from '../icons/nav-arrow-left'
import { HoffHeader } from '../custom/hoff-header'

const FLOW_STEPS = [
  'ItemSelection',
  'ReturnAddress',
  'RefundMethod',
  'ReturnMethod',
  'Confirmation',
  'Success'
] as const

type FlowStep = (typeof FLOW_STEPS)[number]

const getStepProgress = (page: string): number => {
  const index = FLOW_STEPS.indexOf(page as FlowStep)
  if (index === -1) return 0
  return ((index + 1) / FLOW_STEPS.length) * 100
}

export const PortalHeader = () => {
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const { currentPage } = usePages()

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const fullCatalogOpen = searchParams.get('catalog') === 'true'

  const progress = getStepProgress(currentPage)

  const group = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_group
  )

  const isHoff = group === 'hoff'
  const isMisako = group === 'misako'

  if (isMisako) {
    return null
  }

  if (isHoff) {
    return <HoffHeader />
  }

  return (
    <header className="sticky top-0 z-20 flex min-h-16 w-full shrink-0 items-start justify-center gap-4 border-b border-solid border-neutral-200 bg-white px-4 py-6">
      {currentPage === 'ItemSelection' && !fullCatalogOpen ? null : (
        <button
          className="absolute left-3 top-1/2 flex -translate-y-1/2 items-center gap-1 p-2 text-xs font-medium text-neutral-700"
          aria-label="Go back"
          onClick={() => navigate(-1)}
        >
          <NavArrowLeftIcon className="size-6" />
        </button>
      )}
      {settings.branding?.logo_url ? (
        <div className="h-8 max-w-36">
          <img
            src={settings.branding.logo_url}
            height={32}
            width={144}
            alt={settings.branding.title}
            className="h-full w-auto object-contain"
          />
        </div>
      ) : null}
      <div
        className="absolute bottom-0 left-0 h-[1.5px] w-full overflow-hidden bg-transparent"
        aria-hidden={progress === 0}
      >
        <div
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
          className="h-full bg-brand-600 transition-[width] duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </header>
  )
}
